import { IApplicationState, IReduxThunkContext } from '../../../shared/types/store';
import { createReduxStore } from '../../../shared/store';
import { DEFAULT_SUBDOMAIN } from '../../../shared/constants';
import { IApplicationContext } from '../../../shared/types/application';

export function createApplicationState(context: IApplicationContext) {
  const { config } = context;

  const reduxContext: IReduxThunkContext = {
    ...context,
    subdomain: config.get<string>('subdomain') || DEFAULT_SUBDOMAIN,
  };

  const initialState = config.getStrict<IApplicationState>('initialState');

  return createReduxStore(reduxContext, initialState, true);
}
